import Immutable from '@utils/immutable/Immutable';
import { ADD_DISH, ADD_NEW_DISH, CLEAR_ORDER, REMOVE_DISH, REMOVE_DISH_WITH_OPTIONS } from '@constants/menu';
import { clone } from '@utils/lo/lo';
import LocalStorageService from '@services/LocalStorage.service';

const initialState = LocalStorageService.get(LocalStorageService.Keys.ORDERS) || {};

export default (state = initialState, action) => {
  const { type } = action;
  switch (type) {
    case CLEAR_ORDER: {
      const place = action.payload;
      const newState = { ...state, [place.uri]: undefined };
      LocalStorageService.set(LocalStorageService.Keys.ORDERS, newState);
      return Immutable(newState);
    }
    case ADD_DISH: {
      const dish = action.payload;
      const { place } = action;
      const placeOrders = clone(state[place.uri] || []);
      const dishOrder = placeOrders.find(o => o.id === dish.id);

      if (dishOrder) {
        dishOrder.count += 1;
      } else {
        placeOrders.push({
          id: dish.id,
          count: 1,
        });
      }
      const newState = { ...state, [place.uri]: placeOrders };
      LocalStorageService.set(LocalStorageService.Keys.ORDERS, newState);
      return Immutable(newState);
    }
    case REMOVE_DISH: {
      const dish = action.payload;
      const { place } = action;
      const placeOrders = clone(state[place.uri] || []);
      const dishOrder = placeOrders.find(o => o.id === dish.id);

      if (dishOrder) {
        if (dishOrder.count <= 1) {
          placeOrders.splice(placeOrders.indexOf(dishOrder), 1);
        } else {
          dishOrder.count -= 1;
        }
      }

      const newState = { ...state, [place.uri]: placeOrders };
      LocalStorageService.set(LocalStorageService.Keys.ORDERS, newState);
      return Immutable(newState);
    }
    case REMOVE_DISH_WITH_OPTIONS: {
      const orderToRemove = action.payload;
      const { place } = action;
      const placeOrders = clone(state[place.uri] || []);
      
      // Find the exact order to remove (matching both dish ID and options)
      const orderIndex = placeOrders.findIndex(existing => {
        // Check if it's the same dish
        if (existing.id !== orderToRemove.id) return false;
        
        // Check if options are identical
        const existingOptions = existing.options || [];
        const removeOptions = orderToRemove.options || [];
        
        if (existingOptions.length !== removeOptions.length) return false;
        
        // Sort both option arrays by option id for comparison
        const sortedExisting = [...existingOptions].sort((a, b) => a.option.id - b.option.id);
        const sortedRemove = [...removeOptions].sort((a, b) => a.option.id - b.option.id);
        
        // Compare each option
        return sortedExisting.every((existingOpt, index) => {
          const removeOpt = sortedRemove[index];
          return existingOpt.option.id === removeOpt.option.id && existingOpt.count === removeOpt.count;
        });
      });

      if (orderIndex > -1) {
        const order = placeOrders[orderIndex];
        if (order.count <= 1) {
          placeOrders.splice(orderIndex, 1);
        } else {
          order.count -= 1;
        }
      }

      const newState = { ...state, [place.uri]: placeOrders };
      LocalStorageService.set(LocalStorageService.Keys.ORDERS, newState);
      return Immutable(newState);
    }
    case ADD_NEW_DISH: {
      const orderItem = action.payload;
      const { place } = action;

      const placeOrders = clone(state[place.uri] || []);
      
      // Check if there's already an identical dish with the same options
      const existingDish = placeOrders.find(existing => {
        // Check if it's the same dish
        if (existing.id !== orderItem.dish.id) return false;
        
        // Check if options are identical
        const existingOptions = existing.options || [];
        const newOptions = orderItem.options || [];
        
        if (existingOptions.length !== newOptions.length) return false;
        
        // Sort both option arrays by option id for comparison
        const sortedExisting = [...existingOptions].sort((a, b) => a.option.id - b.option.id);
        const sortedNew = [...newOptions].sort((a, b) => a.option.id - b.option.id);
        
        // Compare each option
        return sortedExisting.every((existingOpt, index) => {
          const newOpt = sortedNew[index];
          return existingOpt.option.id === newOpt.option.id && existingOpt.count === newOpt.count;
        });
      });

      if (existingDish) {
        // Increment count of existing dish
        existingDish.count += (orderItem.count || 1);
      } else {
        // Add new dish
        placeOrders.push({
          id: orderItem.dish.id,
          count: orderItem.count || 1,
          // comment: orderItem.comment || null,
          options: orderItem.options || [],
        });
      }

      const newState = { ...state, [place.uri]: placeOrders };
      LocalStorageService.set(LocalStorageService.Keys.ORDERS, newState);
      return Immutable(newState);
    }
    default:
      return state;
  }
};
